import React from "react";
import moment from "moment";

const LoanProgress = ({
  loanSummary,
  requestApprovals,
  openApproversDetailsOpen,
}) => {
  const addStatus = (index, paymentStatus) => {
    const status = paymentStatus?.trim()?.toUpperCase();

    return index <= 2 ? "is-done" : status === "PAID" ? "is-done" : "current";
  };

  const formattedDate = (date, index) => {
    const momentDate = moment(date)?.isValid()
      ? moment(date)?.format("Do MMMM YYYY")
      : "N/A";

    if (index === 0) {
      return `Loan applied on ${momentDate}`;
    } else if (index === 1) {
      if (requestApprovals?.length > 0) {
        return (
          <>
            Loan approved by{" "}
            <span
              style={{
                color: "#06B217",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={openApproversDetailsOpen}
            >
              View Approvers
            </span>
          </>
        );
      } else {
        return `Loan approved on ${momentDate}`;
      }
    } else if (index === 2) {
      return `Loan disbursed: ${momentDate}`;
    } else {
      return momentDate;
    }
  };

  const formatBalance = (amount) => {
    return amount ? Number(amount?.split(" ")[1] || 0)?.toFixed(2) : "0.00";
  };

  return (
    <div className="h-[300px] w-[80%]">
      <div className="wrapper">
        {loanSummary && loanSummary.length > 0 ? (
          <ul className="StepProgress">
            {loanSummary?.map((schedule, index) => (
              <div
                key={index}
                className={`StepProgress-item flex w-full justify-between ${addStatus(
                  index,
                  schedule?.Payment_Status,
                )}`}
              >
                <span className="text-[#005C53] text-[14px]">
                  {formattedDate(schedule?.Schedule_Date, index)}
                </span>
                <span className="text-[#005C53] text-[14px]">
                  KES {formatBalance(schedule?.Schedule_Amount)}
                </span>
              </div>
            ))}
          </ul>
        ) : (
          <div className="text-center text-[#005C53] text-[16px]">
            No loan schedule data available.
          </div>
        )}
      </div>
    </div>
  );
};

export default LoanProgress;
